import RefreshIcon from "@mui/icons-material/Refresh";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Box } from "@mui/material";
import { Button } from "react-admin";
import { Link } from "react-router-dom";
import { SiteContryEnum } from "shared/enums/globalEnums";
import useGrafanaUrl from "./hooks/useGrafanaUrl";

export type GrafanaChartProps = {
  country: SiteContryEnum;
  params: Record<string, string | number>; // must include panelId etc.
  sx?: object;
  isSiteView?: boolean;
};

const GrafanaTelemetryChart = ({ country, params, sx = {}, isSiteView = false }: GrafanaChartProps) => {
  const { graphOnlyUrl, grafanaDashboardUrl, handleRefresh, refreshKey } = useGrafanaUrl(country, params, isSiteView);

  if (!graphOnlyUrl || !grafanaDashboardUrl) {
    return null;
  }

  return (
    <Box width="100%" sx={sx}>
      <Button
        onClick={handleRefresh}
        label="Refresh chart"
        variant="contained"
        sx={{ mb: 2 }}
        startIcon={<RefreshIcon />}
      />
      <Button
        label="Open in Grafana"
        variant="contained"
        sx={{ mb: 2, ml: 2 }}
        startIcon={<ShowChartIcon />}
        component={Link}
        to={grafanaDashboardUrl}
        target="_blank"
        rel="noopener"
      />

      <Box minHeight={500} height={500} width="100%">
        <iframe
          key={refreshKey}
          src={graphOnlyUrl}
          width="100%"
          height="100%"
          title="Grafana Dashboard"
          style={{ border: 0 }}
        />
      </Box>
    </Box>
  );
};

export default GrafanaTelemetryChart;
